import { formatInTimeZone, fromZonedTime } from "date-fns-tz";
import generateTimeframeBounds from "components/widgets/widgetTypes/charts/generateTimeframeBounds";

export const ANALYTICS_TIME_ZONE = "Europe/Madrid";

export const dateInputValue = (date = new Date()) =>
  formatInTimeZone(date, ANALYTICS_TIME_ZONE, "yyyy-MM-dd");

export const customDateRangeBounds = (startDate, endDate) => {
  if (!startDate || !endDate || startDate > endDate) {
    return { start: null, end: null };
  }

  const start = fromZonedTime(
    `${startDate}T00:00:00.000`,
    ANALYTICS_TIME_ZONE
  );
  const end = fromZonedTime(
    `${endDate}T23:59:59.999`,
    ANALYTICS_TIME_ZONE
  );

  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
    return { start: null, end: null };
  }

  return { start, end };
};

export const analyticsDisplayBounds = (
  timeframe,
  startDate,
  endDate,
  referenceDate = new Date()
) => {
  if (timeframe === "custom") {
    return { start: startDate ?? null, end: endDate ?? null };
  }

  return generateTimeframeBounds(timeframe, referenceDate);
};
